import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyEnableSmsVerification',
  initialState: false,
  reducers: {
    setLoyaltyEnableSmsVerification(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyEnableSmsVerification } = slice.actions;

export default slice.reducer;
